import api from "@/services/api";

const state = {
  importHistory: [],
  summary: null,
};

const mutations = {
  SET_IMPORT_HISTORY(state, data) {
    state.importHistory = data;
  },
  SET_SUMMARY(state, data) {
    state.summary = data;
  },
};

const actions = {
  async importReturns({ dispatch }, payload) {
    try {
      const result = await api.post("/reconciliation/import", payload);
      await dispatch("getImportHistory");
      return result.data;
    } catch (error) {
      console.error("Error importing returns:", error.message);
      throw error;
    }
  },

  async getImportHistory({ commit }) {
    try {
      const res = await api.get("/reconciliation/import-history");
      commit("SET_IMPORT_HISTORY", res.data);
      return res.data;
    } catch (error) {
      console.error("Error fetching import history:", error.message);
      throw error;
    }
  },

  async deleteImportBatch({ dispatch }, batchId) {
    try {
      await api.delete(`/reconciliation/import/${batchId}`);
      await dispatch("getImportHistory");
    } catch (error) {
      console.error("Error deleting import batch:", error.message);
      throw error;
    }
  },

  async getSummary({ commit }, params = {}) {
    try {
      const res = await api.get("/reconciliation/summary", { params });
      commit("SET_SUMMARY", res.data);
      return res.data;
    } catch (error) {
      console.error("Error fetching reconciliation summary:", error.message);
      throw error;
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
